/**
 * Base Skill API Contract
 *
 * Mirrors: backend/src/routes/baseSkill.routes.ts
 * 1:1 parity with existing Express routes
 */
import { oc } from "@orpc/contract";
import { z } from "zod";
import { CreateBaseSkillInputSchema, UpdateBaseSkillInputSchema, BaseSkillResponseSchema, } from "@hourly/api/skills";
import { uuidSchema } from "@hourly/api/validation-common";
// ============================================
// Base Skill Contracts
// ============================================
/**
 * POST /api/base-skills
 * Create a new base skill
 */
export const createBaseSkill = oc
    .route({
    method: "POST",
    path: "/base-skills",
    summary: "Create a new base skill",
    tags: ["Skills"],
    successStatus: 201,
})
    .input(CreateBaseSkillInputSchema.omit({ companyId: true }))
    .output(BaseSkillResponseSchema);
/**
 * GET /api/base-skills/:id
 * Get a base skill by ID
 */
export const getBaseSkill = oc
    .route({
    method: "GET",
    path: "/base-skills/{id}",
    summary: "Get base skill by ID",
    tags: ["Skills"],
})
    .input(z.object({ id: uuidSchema }))
    .output(BaseSkillResponseSchema);
/**
 * GET /api/base-skills
 * List base skills for the authenticated user's company
 */
export const getBaseSkillsByCompany = oc
    .route({
    method: "GET",
    path: "/base-skills",
    summary: "List base skills for a company",
    tags: ["Skills"],
})
    .input(z.object({}))
    .output(z.array(BaseSkillResponseSchema));
/**
 * PATCH /api/base-skills/:id
 * Update a base skill
 */
export const updateBaseSkill = oc
    .route({
    method: "PATCH",
    path: "/base-skills/{id}",
    summary: "Update a base skill",
    tags: ["Skills"],
})
    .input(z.object({ id: uuidSchema }).merge(UpdateBaseSkillInputSchema))
    .output(BaseSkillResponseSchema);
/**
 * DELETE /api/base-skills/:id
 * Delete a base skill
 */
export const deleteBaseSkill = oc
    .route({
    method: "DELETE",
    path: "/base-skills/{id}",
    summary: "Delete a base skill",
    tags: ["Skills"],
    successStatus: 204,
})
    .input(z.object({ id: uuidSchema }))
    .output(z.void());
// ============================================
// Contract Router
// ============================================
export const baseSkillContract = {
    createBaseSkill,
    getBaseSkill,
    getBaseSkillsByCompany,
    updateBaseSkill,
    deleteBaseSkill,
};
//# sourceMappingURL=baseSkill.js.map